import { render, staticRenderFns } from "./ReservationCalendar.vue?vue&type=template&id=2f875e27"
import script from "./ReservationCalendar.vue?vue&type=script&lang=js"
export * from "./ReservationCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports